module.exports = __webpack_public_path__ + "static/img/product1new.f2a10101.png";